// ============================================================================
// Admin Routes
// ============================================================================

// Dashboard
export const ADMIN_DASHBOARD = '/admin/dashboard';

// Courses
export const ADMIN_COURSE_CATALOG = '/admin/course/course-catalog';
export const ADMIN_COURSE_ADD = '/admin/course/add-course';
export const ADMIN_COURSE_CREATE_MANUAL = '/admin/course/create-manual';
export const ADMIN_SCORM_UPLOAD = '/admin/course/scorm-upload';

// Private avatar library — user-uploaded Photo Avatars (CRUD)
export const ADMIN_AVATAR_LIBRARY = '/admin/avatars/library';
export const ADMIN_COURSE_BUILD = '/admin/course/build-course';
export const ADMIN_COURSE_EDIT = '/admin/edit-course'; // Route param: :id
export const ADMIN_COURSE_DETAILS = '/admin/course/details'; // Route param: :id
export const ADMIN_COURSE_PREVIEW = '/admin/course/preview'; // Route param: :id
export const ADMIN_COURSE_TRACKING = '/admin/course-tracking'; // Route param: :courseId
export const ADMIN_COURSE_PLAYER = '/admin/course-player'; // Route param: :courseId
export const ADMIN_COURSE_CATEGORIES = '/admin/course/categories';

// Course Assignments
export const ADMIN_COURSE_ASSIGNMENT = '/admin/course/assignment';
export const ADMIN_COURSE_ASSIGNMENT_ANALYTICS = '/admin/course/assignments/analytics';
export const ADMIN_COURSE_USER_PROGRESS = '/admin/course/assignments/user'; // Route params: :userId/course/:courseId/progress

// Users
export const ADMIN_USERS = '/admin/users';
export const ADMIN_USER_COURSES = '/admin/users'; // Route param: :userId/courses
export const ADMIN_USER_CERTIFICATIONS = '/admin/users'; // Route param: :userId/certifications
export const ADMIN_USER_CERTIFICATION_PROGRESS = '/admin/users'; // Route params: :userId/certifications/:certificationId/progress
export const ADMIN_USERS_DEPARTMENTS = '/admin/users/departments';
export const ADMIN_USERS_INVITATIONS = '/admin/users/invitations';

// Groups
export const ADMIN_GROUP_COURSES = '/admin/groups'; // Route param: :groupKey/courses

// Roles
export const ADMIN_ROLES = '/admin/roles';
export const ADMIN_ROLE_COURSES = '/admin/roles'; // Route param: :roleKey/courses
export const ADMIN_ROLE_ASSIGN_PERMISSIONS = '/admin/roles/assign-permissions';
export const ADMIN_ROLE_PERMISSIONS = '/admin/roles'; // Route param: :roleKey/permissions

// Tenants
export const ADMIN_TENANTS = '/admin/tenants';
export const ADMIN_TENANT_CREATE = '/admin/tenants/create';
export const ADMIN_TENANT_EDIT = '/admin/tenants/:tenant_key/edit'; // navigate: `/admin/tenants/${tenant_key}/edit`

// Settings
export const ADMIN_SETTINGS = '/admin/settings';
export const ADMIN_SETTINGS_BUSINESS = '/admin/settings/business';
export const ADMIN_SETTINGS_UI_CUSTOMIZATION = '/admin/settings/ui-customization';
export const ADMIN_SETTINGS_TICKET_REQUESTS = '/admin/settings/ticket-requests';
export const ADMIN_SETTINGS_TICKET_DETAIL = '/admin/settings/ticket-requests'; // Route param: :ticketId
export const ADMIN_SETTINGS_WEBHOOKS = '/admin/settings/webhooks';
export const ADMIN_SETTINGS_REDIS_CACHE = '/admin/settings/redis-cache';
export const ADMIN_SETTINGS_AI_MODELS = '/admin/settings/ai-models';

// Analytics
export const ADMIN_ANALYTICS = '/admin/analytics';
export const ADMIN_ANALYTICS_COURSE_PERFORMANCE = '/admin/analytics/course-performance';
export const ADMIN_ANALYTICS_LEARNING_PATH_PERFORMANCE = '/admin/analytics/learning-path-performance';
export const ADMIN_ANALYTICS_CERTIFICATION_PERFORMANCE = '/admin/analytics/certification-performance';
export const ADMIN_ANALYTICS_EMPLOYEE_PROGRESS = '/admin/analytics/employee-progress';
export const ADMIN_ANALYTICS_MY_TEAM_PROGRESS = '/admin/analytics/my-team-progress';
export const ADMIN_ANALYTICS_DEPARTMENT_PROGRESS = '/admin/analytics/department-progress';
export const ADMIN_ANALYTICS_ROLE_PROGRESS = '/admin/analytics/role-progress';
export const ADMIN_ANALYTICS_COURSE_USERS = '/admin/course-performance'; // Route param: :courseId/users
export const ADMIN_ANALYTICS_LP_COURSE_USERS = '/admin/learning-path-performance'; // Route param: :learningPathId/courses/users
export const ADMIN_ANALYTICS_LP_USER_PROGRESS = '/admin/learning-paths'; // Route params: :learningPathId/users/:userId/progress
export const ADMIN_ANALYTICS_CERT_USERS = '/admin/certification-performance'; // Route param: :certificationId/performance

// Training Status Report
export const ADMIN_TRAINING_STATUS_REPORT = '/admin/training-status-report';
    
// Certifications
export const ADMIN_CERTIFICATIONS = '/admin/certifications';
export const ADMIN_CERTIFICATION_CREATE = '/admin/certification/create';
export const ADMIN_CERTIFICATION_CREATE_MANUAL = '/admin/certification/create-manual';
export const ADMIN_CERTIFICATION_DETAILS = '/admin/certifications'; // Route param: :id
export const ADMIN_CERTIFICATION_GENERATE = '/admin/certifications/generate'; // Route param: :id
export const ADMIN_CERTIFICATION_EXAM = '/admin/certifications'; // Route param: :id/exam
export const ADMIN_CERTIFICATION_PREVIEW = '/admin/certification/preview'; // Route param: :id
export const ADMIN_CERTIFICATION_ASSIGNMENT = '/admin/certification/assignment';
export const ADMIN_CERTIFICATION_ASSIGNMENT_ANALYTICS = '/admin/certification/assignments/analytics';

// Learning Paths
export const ADMIN_LEARNING_PATHS = '/admin/learning-paths';
export const ADMIN_LEARNING_PATH_CREATE = '/admin/learning-paths/create';
export const ADMIN_LEARNING_PATH_EDIT = '/admin/learning-paths'; // Route param: :id
export const ADMIN_LEARNING_PATH_GENERATE = '/admin/learning-paths/generate'; // Route param: :orchestration_id
export const ADMIN_LEARNING_PATH_PREVIEW = '/admin/learning-paths/preview'; // Route param: :learning_path_id
export const ADMIN_LEARNING_PATH_ASSIGNMENT = '/admin/learning-path/assignment';
export const ADMIN_LEARNING_PATH_ASSIGNMENT_ANALYTICS = '/admin/learning-path/assignments/analytics';

// Learning Path Workflows
export const ADMIN_LP_WORKFLOW_LIST = '/admin/learning-paths/workflow';
export const ADMIN_LP_WORKFLOW_CREATE = '/admin/learning-paths/workflow/create';
export const ADMIN_LP_WORKFLOW_EDIT = '/admin/learning-paths/workflow'; // Route param: :id/edit
export const ADMIN_LP_WORKFLOW_STATUS = '/admin/learning-paths/workflow'; // Route param: :id

// Assessments
export const ADMIN_ASSESSMENTS = '/admin/assessments';

// Gamification
export const ADMIN_LEADERBOARD = '/admin/leaderboard';
export const ADMIN_GAMIFICATION_ACHIEVEMENTS = '/admin/gamification/achievements';
export const ADMIN_GAMIFICATION_REWARDS = '/admin/gamification/rewards';
export const ADMIN_GAMIFICATION_BADGES = '/admin/gamification/badge-management';
export const ADMIN_GAMIFICATION_USER_ACHIEVEMENTS = '/admin/gamification/user-achievements';
export const ADMIN_GAMIFICATION_USER_ACHIEVEMENT_DETAIL = '/admin/gamification/user-achievements'; // Route param: :userId

// Reports
export const ADMIN_REPORTS = '/admin/reports';
export const ADMIN_REPORTS_ACTIVITY = '/admin/reports/activity';
export const ADMIN_REPORTS_TRENDING = '/admin/reports/trending-topics';
export const ADMIN_REPORTS_AUDIT_TRAIL = '/admin/reports/audit-trail';
export const ADMIN_REPORTS_TENANT = '/admin/reports/tenant-reports';
export const ADMIN_REPORTS_AI_COST = '/admin/reports/ai-cost-tracking';
export const ADMIN_AI_USAGE = '/admin/reports/ai-usage';

// Reporting V2 - Dashboards
export const ADMIN_REPORTING_ADMIN_OVERVIEW = '/admin/reporting/dashboards/admin-overview';
export const ADMIN_REPORTING_EXECUTIVE_SUMMARY = '/admin/reporting/dashboards/executive-summary';
export const ADMIN_REPORTING_MANAGER_TEAM = '/admin/reporting/dashboards/manager-team';
export const ADMIN_REPORTING_LEARNER_PROGRESS = '/admin/reporting/dashboards/learner-progress';
export const ADMIN_REPORTING_DEPARTMENT_PERFORMANCE = '/admin/reporting/dashboards/department-performance';
export const ADMIN_REPORTING_COURSE_ANALYTICS = '/admin/reporting/dashboards/course-analytics';

// Reporting V2 - Reports
export const ADMIN_REPORTING_GENERATE = '/admin/reporting/reports/generate';
export const ADMIN_REPORTING_SAVED = '/admin/reporting/reports/saved';
export const ADMIN_REPORTING_DETAIL = '/admin/reporting/reports'; // Route param: :snapshotId

// Reporting V2 - Schedules
export const ADMIN_REPORTING_SCHEDULES = '/admin/reporting/schedules';
export const ADMIN_REPORTING_SCHEDULE_CREATE = '/admin/reporting/schedules/create';
export const ADMIN_REPORTING_SCHEDULE_DETAIL = '/admin/reporting/schedules'; // Route param: :scheduleId
export const ADMIN_REPORTING_SCHEDULE_EDIT = '/admin/reporting/schedules'; // Route param: :scheduleId/edit

// Reporting V2 - Subscriptions
export const ADMIN_REPORTING_SUBSCRIPTIONS = '/admin/reporting/subscriptions';
export const ADMIN_REPORTING_SUBSCRIPTION_CREATE = '/admin/reporting/subscriptions/create';
export const ADMIN_REPORTING_SUBSCRIPTION_DETAIL = '/admin/reporting/subscriptions'; // Route param: :subscriptionId
export const ADMIN_REPORTING_SUBSCRIPTION_EDIT = '/admin/reporting/subscriptions'; // Route param: :subscriptionId/edit

// Enterprise
export const ADMIN_CREDIT_PLANS = '/admin/enterprise/credit-plans';
export const ADMIN_CREDIT_PLAN_CREATE = '/admin/enterprise/credit-plans/new';
export const ADMIN_CREDIT_PLAN_EDIT = '/admin/enterprise/credit-plans/:plan_key/edit'; // navigate: `/admin/enterprise/credit-plans/${plan_key}/edit`
export const ADMIN_TENANT_CREDIT_PLANS = '/admin/enterprise/tenant-credit-plans';
export const ADMIN_SSO_CONFIGURATION = '/admin/enterprise/sso-configuration';
export const ADMIN_SSO_ADD = '/admin/enterprise/sso-configuration/new';
export const ADMIN_SSO_EDIT = '/admin/enterprise/sso-configuration/edit'; // Route param: :id
export const ADMIN_SCIM_CONFIGURATION = '/admin/enterprise/scim-configuration';
// LTI Deep Linking content picker. Opened by an LtiDeepLinkingRequest launch,
// so it is reached from inside the LMS rather than from Skillzen navigation.
export const LTI_CONTENT_SELECT = '/lti/select';
// Shown when an LMS-launched session ends. Lives under /lti/ so the LMS may
// frame it; the login page never may.
export const LTI_SIGNED_OUT = '/lti/signed-out';

export const ADMIN_LTI_INTEGRATIONS = '/admin/enterprise/lti-integrations';
export const ADMIN_LTI_ADD = '/admin/enterprise/lti-integrations/new';
export const ADMIN_LTI_EDIT = '/admin/enterprise/lti-integrations/edit'; // Route param: :id
export const ADMIN_EMAIL_TEMPLATES = '/admin/enterprise/email-templates';
export const ADMIN_EMAIL_TEMPLATE_CREATE = '/admin/enterprise/email-templates/create';
export const ADMIN_EMAIL_TEMPLATE_EDIT = '/admin/enterprise/email-templates'; // Route param: :id/edit
export const ADMIN_EMAIL_TEMPLATE_VISUAL_EDITOR = '/admin/enterprise/email-templates'; // Route param: :id/visual-editor
export const ADMIN_CERTIFICATE_TEMPLATES = '/admin/enterprise/certificate-templates';
export const ADMIN_CERTIFICATE_TEMPLATE_CREATE = '/admin/enterprise/certificate-templates/create';
export const ADMIN_CERTIFICATE_TEMPLATE_EDIT = '/admin/enterprise/certificate-templates'; // Route param: :id/edit

// Knowledge
export const ADMIN_KNOWLEDGE_DOCUMENTS = '/admin/knowledge/documents';
export const ADMIN_KNOWLEDGE_DOCUMENT_DETAIL = '/admin/knowledge/documents'; // Route param: :storeId
export const ADMIN_KNOWLEDGE_MANAGE_DOCUMENTS = '/admin/knowledge/manage-documents';

// Reviews
export const ADMIN_REVIEWS = '/admin/reviews';

// Email Logs
export const ADMIN_EMAIL_LOGS = '/admin/email-logs';

// Notifications
export const ADMIN_NOTIFICATIONS = '/admin/notifications';
export const ADMIN_NOTIFICATIONS_SETTINGS = '/admin/notifications/settings';
export const ADMIN_MY_NOTIFICATIONS = '/admin/notifications/my-notifications';
export const ADMIN_NOTIFICATION_SUBSCRIBERS = '/admin/notifications/subscribers';

// AI Learn & Live Chat
export const ADMIN_AI_LEARN = '/admin/ai-learn'; // Route param: :courseId
export const ADMIN_LIVE_CHAT = '/admin/live-chat';
export const ADMIN_LIVE_CHAT_CONVERSATION = '/admin/live-chat'; // Route param: :conversationId

// Profile
export const ADMIN_PROFILE = '/admin/profile';

// ============================================================================
// Learner Routes
// ============================================================================

// Dashboard
export const LEARNER_DASHBOARD = '/learn/dashboard';

// Courses
export const LEARNER_COURSES = '/learn/courses';
export const LEARNER_COURSE_DETAIL = '/learn/course'; // Route param: :id
export const LEARNER_STUDY = '/learn/study'; // Route param: :courseId

// Learning Paths
export const LEARNER_LEARNING_PATHS = '/learn/learning-paths';
export const LEARNER_LEARNING_PATH_DETAIL = '/learn/learning-paths'; // Route param: :learning_path_id

// Progress & Achievements
export const LEARNER_PROGRESS = '/learn/progress';
export const LEARNER_ACHIEVEMENTS = '/learn/achievements';
export const LEARNER_MY_ACHIEVEMENTS = '/learn/my-achievements';
export const LEARNER_LEADERBOARD = '/learn/leaderboard';
export const LEARNER_STREAK_LEADERBOARD = '/learn/streak-leaderboard';

// Schedule
export const LEARNER_SCHEDULE = '/learn/schedule';

// Certificates & Certifications
export const LEARNER_CERTIFICATES = '/learn/certificates';
export const LEARNER_CERTIFICATIONS = '/learn/certifications';
export const LEARNER_CERTIFICATION_DETAIL = '/learn/certification'; // Route param: :id

// Exams
export const LEARNER_EXAMS = '/learn/exams';
export const LEARNER_EXAM_START = '/learn/exams/start'; // Route param: :examId
export const LEARNER_EXAM_DO = '/learn/exams/do-exam'; // Route param: :examId
export const LEARNER_EXAM_SUCCESS = '/learn/exams/success'; // Route param: :examId
export const LEARNER_EXAM_RESULTS = '/learn/exams/results'; // Route param: :examId

// Community
export const LEARNER_FORUMS = '/learn/forums';
export const LEARNER_STUDY_GROUPS = '/learn/study-groups';

// Career & Skills
export const LEARNER_CAREER = '/learn/career';
export const LEARNER_SKILLS = '/learn/skills';

// Library & Downloads
export const LEARNER_LIBRARY = '/learn/library';
export const LEARNER_DOWNLOADS = '/learn/downloads';

// Assessments
export const LEARNER_ASSESSMENTS = '/learn/assessments';

// Help & Support
export const LEARNER_HELP = '/learn/help';
export const LEARNER_MY_REVIEWS = '/learn/my-reviews';

// Tickets
export const LEARNER_TICKETS = '/learn/tickets';
export const LEARNER_TICKET_CREATE = '/learn/tickets/create';
export const LEARNER_TICKET_CHAT = '/learn/tickets'; // Route param: :ticketId/chat

// Live Chat
export const LEARNER_LIVE_CHAT = '/learn/live-chat';
export const LEARNER_LIVE_CHAT_CONVERSATION = '/learn/live-chat'; // Route param: :conversationId

// Notifications
export const LEARNER_NOTIFICATIONS = '/learn/notifications';
export const LEARNER_NOTIFICATIONS_SETTINGS = '/learn/notifications/settings';

// Profile
export const LEARNER_PROFILE = '/learn/profile';

// ============================================================================
// Auth Routes
// ============================================================================

export const AUTH_LOGIN = '/login';
export const AUTH_REGISTER = '/register';
export const AUTH_REGISTER_INVITE = '/register-invite';
export const AUTH_FORGOT_PASSWORD = '/forgot-password';
export const AUTH_RESET_PASSWORD = '/reset-password';
export const AUTH_VERIFY_EMAIL = '/verify-email';
export const AUTH_HANDLE_TOKEN = '/handle-token';
export const AUTH_ACTIVATE_ACCOUNT = '/activate-account';

// ============================================================================
// Error Routes
// ============================================================================

export const ERROR_UNAUTHORIZED = '/unauthorized';
export const ERROR_ACCESS_DENIED = '/access-denied';
export const ERROR_TENANT_BLOCKED = '/tenant-blocked';
export const ERROR_INVALID_INVITATION = '/invalid-invitation';

// ============================================================================
// Public Routes
// ============================================================================

export const PUBLIC_CERTIFICATE_VERIFY = '/certificate/verify'; // Route param: :certificateNumber
